import { useEffect, useState } from "react";
import { Col, Form, Row, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchAfiliados } from "../../reducers/afiliado_slice";
import SelectAfiliado from "../afiliado/SelectAfiliado";
import SelectInmueble from "../inmueble/SelectInmueble";
import SelectPersonas from "../persona/SelectPersonas";
import { getCuotaNombre } from "../../util/valueCalculator";

const initialState = {
    id_proyectista: "",
    cuotas_al_dia: false
}

const TabInvolucrados = ({
    datos,
    tipoProceso,
    permitirCambios,
    esResellado,
    handleListaPropietariosChange,
    handleSelect,
    errors,
    rolActivo,
    verificaciones,
    cuotas
}) => {

     const datgeneralList = useSelector((state) => state.datgeneral.datgeneralList);
     const xcuotas = datgeneralList[0]?.cuotas_tolerancia || 0;
    return (
        <>
           <Row>
                <Col>
                <SelectAfiliado onSelect={handleSelect} afiliado={datos.proyectista} labelText='Proyectista'
                    permitirEdicion={tipoProceso!=="transferir" && tipoProceso!=="editar" && permitirCambios && rolActivo?.alias !=="afiliado"}/>
                
                </Col>
            </Row>
            
            {verificaciones.proyectistaAportes && 
            <>
            {verificaciones.proyectistaAportes === "sin_pendientes"? <div className="alert alert-success" role="alert">
            El afiliado está habilitado para visar{parseInt(xcuotas)>0 ? `(teniendo en cuenta ${xcuotas} cuota(s) de tolerancia)`:""}
            </div>
            : <>
                <div className="alert alert-danger" role="alert">
            El afiliado tiene aportes pendientes  {parseInt(xcuotas)>0 ? `(teniendo en cuenta ${xcuotas} cuota(s) de tolerancia)`:""}
            </div>
                <Form.Label>Cuotas Pendientes</Form.Label>

                <Table hover size="sm" responsive>
                    <thead style={{ backgroundColor: '#b2aea3' }}>
                    <tr>
                        <th>Cuota</th>
                        <th>Monto CAT</th>
                        <th>Monto CAB</th>
                        <th>Total</th>
                        <th>Estado</th>
                    </tr>
                    </thead>
                    <tbody>
                    {cuotas.length === 0 ? (
                        <tr>
                        <td colSpan="6">No hay cuotas pendientes</td>
                        </tr>
                    ) : (
                        cuotas.map((cuota, index) => {
                            const catDebe = !cuota.id_recibo_cat? parseFloat(cuota.monto_cat||0) : 0
                            const cabDebe = !cuota.id_recibo_cab? parseFloat(cuota.monto_cab||0) : 0
                        return (
                        <tr key={cuota.id}>
                            <td>{getCuotaNombre(cuota.cuota)}</td>
                            <td >
                            {(catDebe === 0 && "_____") || `${catDebe} Bs.`}
                            </td>
                            <td>
                            {(cabDebe === 0 && "_____") || `${cabDebe} Bs.`}
                            </td>
                            <td >
                            {catDebe + cabDebe} Bs.
                            </td>
                            <td>{cuota.estado === 'pagada' ? 'Pagada' : 'No Pagada'}</td>
                        </tr>
                        )})
                    )}
                    </tbody>
                </Table>
            </>}
            </>
            }
          <Row>
                <Col>
                <SelectInmueble labelText="Inmueble" onSelect={handleSelect} 
                            inmuebleSelected={datos.inmueble} 
                            permitirEdicion={(!esResellado && permitirCambios)}
                            />
                </Col>
                <Col>

                <SelectPersonas
                labelText="Propietario(s)" onSelect={handleListaPropietariosChange} 
                personasSelected={datos.propietarios} simplePersona={true}
                errorFeedback={{show:(tipoProceso === "transferir" && errors.noCambioPropietario),
                                message:"Debe cambiar de propietario para realizar la transferencia."
                }}
                permitirEdicion={(!esResellado && (permitirCambios || tipoProceso==="transferir"))}
            />
                </Col>
            </Row>

         
        </>
    )
}

export default TabInvolucrados;